var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4902_75913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2526 4.99214C14.0859 4.99214 12.5859 4.90738 12.5859 3.29687C12.5859 3.04257 12.4193 2.87305 12.1693 2.87305C11.9193 2.87305 11.7526 3.04257 11.7526 3.29687C11.7526 3.46639 11.6693 4.99214 10.0859 4.99214C9.83594 4.99214 9.66927 5.16167 9.66927 5.41596C9.66927 5.67025 9.83594 5.83978 10.0859 5.83978C10.2526 5.83978 11.7526 5.92454 11.7526 7.53505C11.7526 7.78934 11.9193 7.95887 12.1693 7.95887C12.4193 7.95887 12.5859 7.78934 12.5859 7.53505C12.5859 7.36552 12.6693 5.83978 14.2526 5.83978C14.5026 5.83978 14.6693 5.67025 14.6693 5.41596C14.6693 5.16167 14.5026 4.99214 14.2526 4.99214Z",
    fill: "url(#paint0_linear_4902_75913)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 7.78934L8.7526 7.45029C7.83594 7.196 7.08594 6.51789 6.83594 5.50072L6.5026 4.22927C6.33594 3.55116 5.41927 3.55116 5.2526 4.22927L5.0026 5.50072C4.7526 6.43312 4.08594 7.196 3.08594 7.45029L1.83594 7.78934C1.16927 7.95887 1.16927 8.89127 1.83594 9.0608L3.08594 9.39985C4.0026 9.65414 4.7526 10.3323 5.0026 11.3494L5.33594 12.6209C5.5026 13.299 6.41927 13.299 6.58594 12.6209L6.91927 11.3494C7.16927 10.417 7.83594 9.65414 8.83594 9.39985L10.0859 9.0608C10.6693 8.89127 10.6693 7.87411 10.0026 7.78934Z",
    fill: "url(#paint1_linear_4902_75913)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4902_75913",
    x: 0.335938,
    y: 2.87305,
    width: 15.3359,
    height: 12.2568,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4902_75913"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4902_75913",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4902_75913",
    x1: 5.5,
    y1: 7.99805,
    x2: 3.5,
    y2: 14.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEB733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4902_75913",
    x1: 5.5,
    y1: 7.99805,
    x2: 3.5,
    y2: 14.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEB733"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/Sparkles.a63309e798ac65c5f517c59a24758bb5.svg";
export { ForwardRef as ReactComponent };